module.exports = __webpack_public_path__ + "img/pro_two_7.bf59924d.jpg";